import { useState } from "react";
import type { Editor } from "./canvas";
import type { TLShapeId } from "@tldraw/tlschema";
import { Modal } from "./Modal";
import { exportTracingSheet } from "./trace-export";

export function TraceExportDialog({
  editor,
  id,
  close,
}: {
  editor: Editor;
  id: TLShapeId;
  close: () => void;
}) {
  const [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const trace = editor.getShape(id);
  return (
    <Modal title="Export tracing sheet" close={busy ? () => {} : close}>
      <p>
        <strong>
          {trace?.type === "trace" ? trace.props.name : "Tracing sheet"}
        </strong>
      </p>
      <p>This paper’s artwork only · A3 · Fit to page.</p>
      <p className="muted">
        The underlying plan, paper tint and discussion comments are excluded.
      </p>
      {error && <p role="alert">{error}</p>}
      <div className="modal-actions">
        <button disabled={busy} onClick={close}>
          Cancel
        </button>
        <button
          className="primary"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            setError("");
            try {
              const current = editor.getShape(id);
              if (current?.type !== "trace" || editor.isShapeHidden(current))
                throw new Error("This tracing sheet is no longer available.");
              await exportTracingSheet(editor, current);
              close();
            } catch (error) {
              setError((error as Error).message);
            } finally {
              setBusy(false);
            }
          }}
        >
          {busy ? "Exporting…" : "Download PDF"}
        </button>
      </div>
    </Modal>
  );
}
